import React, { useState } from 'react';

interface NoteComposerProps {
  disabled?: boolean;
  onSubmit: (text: string) => Promise<void>;
}

const NoteComposer: React.FC<NoteComposerProps> = ({ disabled = false, onSubmit }) => {
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const canSend = !disabled && !sending && text.trim().length > 0;

  const submit = async () => {
    if (!canSend) return;
    setSending(true);
    setError('');
    try {
      await onSubmit(text.trim());
      setText('');
    } catch {
      setError('No se pudo guardar la nota.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      style={{
        borderTop: '1px solid var(--border)',
        padding: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        background: 'var(--card)',
      }}
    >
      {error && <div style={{ fontSize: 12, color: 'var(--destructive)' }}>{error}</div>}
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
            e.preventDefault();
            submit();
          }
        }}
        rows={3}
        disabled={disabled || sending}
        placeholder="Escribe una nota…"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          border: '1px solid var(--border)',
          borderRadius: 8,
          padding: 8,
          fontSize: 14,
          fontFamily: 'inherit',
          resize: 'vertical',
          outline: 'none',
        }}
      />
      <button
        onClick={submit}
        disabled={!canSend}
        style={{
          // Left-aligned so it never sits under the agent's floating launcher,
          // which occupies the bottom-right corner.
          alignSelf: 'flex-start',
          border: 'none',
          background: 'var(--primary)',
          color: 'var(--card)',
          borderRadius: 8,
          padding: '8px 16px',
          fontSize: 13,
          fontWeight: 600,
          cursor: canSend ? 'pointer' : 'default',
          opacity: canSend ? 1 : 0.6,
        }}
      >
        {sending ? 'Guardando…' : 'Añadir nota'}
      </button>
    </div>
  );
};

export default NoteComposer;
